import * as React from "react";
import {WorkspaceView} from "../../../../model/workspace/WorkspaceView";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import IconSmall from "../../../../hiberUiKit/src/atoms/Icon/IconSmall";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import "./viewSelector.scss"
import DropDownMenu, {DropDownMenuItem} from "../../../../hiberUiKit/src/molecules/DropDownMenu/DropDownMenu";
import {isPhoneScreen} from "../../../../utils/Utils";
import classNames = require("classnames");

interface IProps {
	views: WorkspaceView[];
	favouritesViews: string[];
	selectedView: WorkspaceView;
	onViewSelect: (view: WorkspaceView) => void;
	onDeleteView: (view: WorkspaceView) => void;
	onRenameView: (view: WorkspaceView) => void;
	onDuplicateView: (view: WorkspaceView) => void;
	onCopyToMyView: (view: WorkspaceView) => void;
	/**
	 * Ignore selection for displaying selected view.
	 */
	ignoreSelection?: boolean;
}

interface IState {
	menuDropDownVisible: boolean;
	isGlobalSelected: boolean;
	selectedView: WorkspaceView
}

export default class ViewSelector extends React.Component<IProps, IState> {
	root: HTMLDivElement | null = null;

	constructor(props: IProps) {
		super(props);

		this.state = {menuDropDownVisible: false, isGlobalSelected: props.selectedView.global, selectedView: props.selectedView};
	}

	componentWillReceiveProps(nextProps: IProps) {
		if ((!nextProps.views.map(v => v.id).some((vId) => vId == this.state.selectedView.id))
			|| (!nextProps.favouritesViews.some(vId => vId == nextProps.selectedView.id))) {
			this.setState({selectedView: nextProps.selectedView})
		}
	}

	render() {
		const classes = classNames({
			"c-view-selector": true,
			"reset-dropdown-right": true,
			"is-selected": this.props.ignoreSelection ? false : this.props.selectedView.id == this.state.selectedView.id,
		});
		const submenuItems: DropDownMenuItem<WorkspaceView>[] = this.props.views.filter(
			v => v.global == this.state.isGlobalSelected)
			.map((v, index) => {
				return {
					item: v,
					submenuItems: [
						{
							label: "Duplicate",
							onClick: () => this.setState({menuDropDownVisible: false}, () => this.props.onDuplicateView(v))
						},
						{
							label: "Rename",
							onClick: () => this.setState({menuDropDownVisible: false}, () => this.props.onRenameView(v)),
							disabled: this.state.isGlobalSelected && !index
						},
						...this.state.isGlobalSelected ? [
							{
								label: "Copy to My Views",
								onClick: () => this.setState({menuDropDownVisible: false}, () => this.props.onCopyToMyView(v))
							}] : [],
						{
							label: "Delete",
							onClick: () => this.setState({menuDropDownVisible: false}, () => this.props.onDeleteView(v)),
							disabled: this.state.isGlobalSelected && !index
						}
					]
				}
			});

		return (
			<div className={classes} ref={el => this.root = el}>
				<div className={"c-view-selector_content"}
					 onClick={this.onClick}>
					<div className="c-view-selector_wrapper">
						<span className="c-view-selector_wrapper_title">
							{this.state.selectedView.name}
						</span>
						<span className="c-view-selector_wrapper_counter">
							{/*TODO use proper prop with value*/}
							{/*48*/}
						</span>
					</div>
				</div>
				<div className={`c-view-selector_menu ${this.state.menuDropDownVisible ? "open" : ""}`}
					 onClick={this.toggleMenu}>
					<i className={"fa fa-fw fa-caret-down"}/>
				</div>
				{this.state.menuDropDownVisible &&
				<DropDownWrapper width={"auto"} onOutsideClick={this.onOutsideClick}>
					<div className={"c-view-selector_menu_view-type"}>
						<div className={`c-view-selector_menu_view-type_option ${this.state.isGlobalSelected ? "selected" : ""}`}
							 onClick={() => this.setState({isGlobalSelected: true})}>
							<IconSmall icon={Icon.Globe} variant={this.state.isGlobalSelected ? "blue" : "blue_medium"}/>Global
						</div>
						<div className={`c-view-selector_menu_view-type_option ${!this.state.isGlobalSelected ? "selected" : ""}`}
							 onClick={() => this.setState({isGlobalSelected: false})}>
							<IconSmall icon={Icon.User} variant={!this.state.isGlobalSelected ? "blue" : "blue_medium"}/>My Views
						</div>
					</div>
					<DropDownMenu items={submenuItems}
								  itemToId={(item: WorkspaceView) => item.id}
								  itemToLabel={(item: WorkspaceView) => item.name}
								  selectedItemId={this.props.selectedView.id}
								  onSelect={(view: WorkspaceView) =>
									  this.setState({selectedView: view, menuDropDownVisible: false},
										  () => this.props.onViewSelect(view))}/>
				</DropDownWrapper>}
			</div>
		)
	}

	/**
	 * On a desktop the view's name reloads the view, the arrow opens the list. A phone has room for one target,
	 * so the whole field opens the list there.
	 */
	onClick = () => {
		if (isPhoneScreen()) {
			this.toggleMenu();
			return;
		}
		const view = this.props.views.filter(view => view.id === this.state.selectedView.id)[0];
		this.props.onViewSelect(view)
	};

	toggleMenu = () => this.setState({menuDropDownVisible: !this.state.menuDropDownVisible});

	/**
	 * A tap on the field itself is left to its own handlers, which toggle the list; closing it here as well
	 * would open it again straight away.
	 */
	onOutsideClick = (evt: Event) => {
		if (!this.root || !this.root.contains(evt.target as Node)) {
			this.setState({menuDropDownVisible: false});
		}
	};
}
